import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Grupo tipo acordeón para el menú admin. Se puede colapsar/expandir.
 * @param {string} title - Título de la sección (ej. "Operación")
 * @param {Array<{ to: string, label: string, icon?: string, badge?: number }>} items - Enlaces con opcional badge
 * @param {boolean} defaultOpen - Si el acordeón está abierto por defecto
 * @param {function} [onItemClick] - Se llama al hacer clic en un ítem (p. ej. cerrar drawer en móvil)
 */
export default function AdminSidebarGroup({ title, items, defaultOpen = true, onItemClick }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(defaultOpen);

  const basePath = '/admin';
  const isActive = (to) => {
    const path = to ? `${basePath}/${to}` : basePath;
    return location.pathname === path || (to && to !== '#' && location.pathname.startsWith(path + '/'));
  };

  return (
    <div className="border-b border-slate-700/50">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-4 py-3 text-left text-slate-200 hover:bg-slate-800/60 transition-colors"
      >
        <span className="text-sm font-semibold uppercase tracking-wider">{title}</span>
        <span className="text-slate-400 text-xs">{open ? '▼' : '▶'}</span>
      </button>
      {open && (
        <div className="pb-2">
          {items.map((item, idx) => {
            const path = item.to && item.to !== '#' ? `${basePath}/${item.to}` : null;
            const active = path ? isActive(item.to) : false;
            return (
              <button
                key={item.to ? `${item.to}-${item.label}-${idx}` : 'home'}
                type="button"
                onClick={() => {
                  if (path) {
                    onItemClick?.();
                    navigate(path);
                  }
                }}
                disabled={!path}
                className={`w-full flex items-center justify-between gap-2 px-4 py-2.5 text-left text-sm transition-colors ${
                  !path ? 'text-slate-500 cursor-not-allowed' : active ? 'bg-slate-700 text-white' : 'text-slate-300 hover:bg-slate-800/80'
                }`}
              >
                <span className="flex items-center gap-2 truncate">
                  {item.icon && <span>{item.icon}</span>}
                  {item.label}
                </span>
                {item.badge != null && item.badge > 0 && (
                  <span className="flex-shrink-0 min-w-[1.25rem] h-5 px-1.5 rounded-full bg-slate-600 text-xs font-medium flex items-center justify-center">
                    {item.badge > 99 ? '99+' : item.badge}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
